import Seo from "@/components/Seo";
import { FadeUp } from "@/components/Reveal";
import { BUSINESS } from "@/content/siteContent";

const SECTIONS = [
  { title: "Information we collect", body: "When you request a quote or contact us, we collect the details you provide: your name, email address, phone number, move or project details, and any photos or videos you choose to upload so we can prepare an accurate estimate." },
  { title: "How we use it", body: "We use your information only to respond to your request, prepare and deliver estimates, schedule and perform services, and communicate with you about your job. We do not sell, rent, or share your personal information with third parties for their marketing purposes." },
  { title: "Photos and videos", body: "Media you upload is stored securely and used solely to assess the scope of your job. Files are accessible only to our team and are retained only as long as needed to provide your estimate and complete your service." },
  { title: "Data security", body: "Submissions are transmitted over encrypted connections and stored with access controls. While no system is perfectly secure, we take reasonable measures to protect your information." },
  { title: "Your choices", body: `You may request a copy, correction, or deletion of your personal information at any time by emailing ${BUSINESS.email}.` },
  { title: "Changes to this policy", body: "We may update this policy from time to time. The current version will always be posted on this page." },
];

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Home Team Moving Co."
        siteName="Home Team Moving Co."
        description="How Home Team Moving Co. collects, uses, and protects your personal information."
      />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:py-24">
        <FadeUp>
          <p className="eyebrow mb-4">Legal</p>
          <h1 className="font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">Privacy Policy</h1>
          <p className="mt-4 text-sm text-slate-400">Last updated: July 2026</p>
          <p className="mt-6 leading-relaxed text-slate-300">
            {BUSINESS.name} respects your privacy. This policy explains what we collect when you use our website and how we handle it — in plain language.
          </p>
        </FadeUp>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s, i) => (
            <FadeUp key={s.title} delay={i * 0.05}>
              <h2 className="font-display text-xl font-bold uppercase tracking-wide text-gold">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{s.body}</p>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-12 border-t border-white/10 pt-8 text-sm text-slate-400">
          Questions about this policy? Email <a href={BUSINESS.emailHref} className="text-gold">{BUSINESS.email}</a> or call <a href={BUSINESS.phoneHref} className="text-gold">{BUSINESS.phone}</a>.
        </FadeUp>
      </section>
    </>
  );
}
